function getGaCustomerId() {
  let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)')
  const raw = match ? decodeURIComponent(match[1]) : null
  if (raw) {
    match = raw.match(/(\d+\.\d+)$/)
  }
  const gacid = match ? match[1] : null
  if (gacid) {
    return gacid
  }
}

export default function fireEvent({ app: { $gtm }, store }, inject) {
  const userId = store.state.user.details?.id
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    userID: userId || getGaCustomerId()
  })

  inject('fireEvent', payload => {
    const event = {
      event: 'VirtualPageview',
      action: 'pageView',
      pageCategory: 'Virtual Pages',
      virtualPageTitle: document.title,
      virtualPageURL: location.href.replace(location.origin, ''),
      ...payload
    }

    // if (isDev) {
    //   console.log('[fire-event]', event);
    // }

    $gtm.push(event)
  })
}
